module.exports = __webpack_public_path__ + "img/202.6637ed84.jpg";